// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"151":"leistungen","318":"praxis","353":"contact","565":"wissenswertes","601":"career","774":"imprint","957":"privacy"}[chunkId] + "." + {"151":"96833c13","318":"aba9ee46","353":"c7617d35","565":"4250066d","601":"ff6cfd99","774":"6f153b8d","957":"c2c9b303"}[chunkId] + ".js";
};